module.exports = __webpack_public_path__ + "img/jumbopackh2h-badge.cdf5036a.svg";